module.exports = __webpack_public_path__ + "assets/valance-roman.68959576.svg";